let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jK3Hq")).then(() => parcelRequire('12WPT'));